export const NEBULY_DOC_LINK = 'https://docs.nebuly.com/';
export const NEBULY_SDK_LINK = 'https://docs.nebuly.com/tracking/overview';

export const PLAYGROUND_URL = 'https://playground.nebuly.com';
export const PLAYGROUND_V2_URL = 'https://v2.playground.nebuly.com';

export const EMPTY_STATE_MESSAGE = 'No data found for your query';

/** Charts (analytics, retention, datatable): no rows/points for the current query. */
export const CHART_NO_DATA_TITLE = 'No data for this period';
export const CHART_NO_DATA_DESCRIPTION = 'Try a different date range or edit chart settings';

export const CHART_EMPTY_NO_PROJECT_TITLE = 'No project selected';
export const CHART_EMPTY_NO_PROJECT_DESCRIPTION = 'Choose a project to load chart data.';

export const CHART_EMPTY_ERROR_TITLE = 'Something went wrong';
export const CHART_EMPTY_ERROR_DESCRIPTION = 'Please reload the page or try again.';

export const CHART_EMPTY_UNSUPPORTED_TITLE = 'Chart type not supported yet';
export const CHART_EMPTY_UNSUPPORTED_DESCRIPTION = 'This visualization is not available in the editor yet.';
